import { render, staticRenderFns } from "./bus-seat.vue?vue&type=template&id=412c1374"
import script from "./bus-seat.vue?vue&type=script&lang=js"
export * from "./bus-seat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports